import { SVGProps } from "react";

const Edit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.29289 15.707L13.5 5.49989C14.8807 4.11918 17.1193 4.11918 18.5 5.49989C19.8807 6.8806 19.8807 9.11918 18.5 10.4999L8.29289 20.707C8.10536 20.8945 7.851 20.9999 7.58579 20.9999H4C3.44772 20.9999 3 20.5522 3 19.9999V16.4141C3 16.1489 3.10536 15.8945 3.29289 15.707ZM4.5 19.4999V16.6212L14.5607 6.56055C15.3556 5.76562 16.6444 5.76562 17.4393 6.56055C18.2343 7.35547 18.2343 8.6443 17.4393 9.43923L7.37868 19.4999H4.5Z"
      fill="currentColor"
    />
    <path
      d="M12 19.2499C11.5858 19.2499 11.25 19.5857 11.25 19.9999C11.25 20.4141 11.5858 20.7499 12 20.7499H19C19.4142 20.7499 19.75 20.4141 19.75 19.9999C19.75 19.5857 19.4142 19.2499 19 19.2499H12Z"
      fill="currentColor"
    />
  </svg>
);

export default Edit;
